<template>
  <div class="payForward">
    <div class="wrapContent">
      <div v-if="info !== ''">
        <h3>
          <span v-if="info.trade_status == 2" class="success">
            <i class="el-icon-success"></i>
            {{pc_lang.Payment_successful}}
          </span>
          <span v-if="info.trade_status != 2" class="fail">
            <i class="el-icon-error"></i>
            {{pc_lang.Payment_failed}}
          </span>
        </h3>

        <div class="main">
          <h5>Payment Receipt</h5>
          <table>
            <tbody>
              <tr v-for="(val, key) in info.show_data" :key="key">
                <td v-text="key + ' :'"></td>
                <td v-text="val"></td>
              </tr>
            </tbody>
          </table>

          <div class="btns">
            <!-- <el-button type="primary" size="small" @click="$router.push({name: 'Riches'})">继续充值</el-button> -->
            <el-button type="primary" size="small" @click="$router.push({name: 'Riches'})" v-show="info.trade_type == 'recharge'">{{pc_lang.Next_top_up}}</el-button>
            <el-button type="primary" size="small" @click="submit">{{pc_lang.Confirmation_message}}</el-button>
          </div>
        </div>
      </div>

      <div v-if="info !== '' && !!info.push_data" v-show="0">
        <form :action="info.push_data.returnUrl" target="_blank" method="post" id="postForm" ref="postForm">
          <input type="text" v-for="(val, key) in info.push_data" :name="key" :value="val" :key="key" v-if="key != 'returnUrl'">
        </form>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import * as API_PAY from '@/api/pay'
import both from '@/utils/storage'

export default {
  name: 'PayForward',
  components: {

  },
  computed: {

  },
  data() {
    return {
      info: ''
    }
  },
  async mounted() {
    console.log()
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      let params = this.$route.query
      API_PAY.payForward(params).then(res=> {
        let data = res.data
        let temp = {}
        for(let k in data.show_data) {
          let kk = this.titleCase(k.replace(/555555/g,'&').replace(/_/g,' '))
          console.log(kk)
          if (kk == 'Date & Time') {
            temp[kk] = both.getChinaTime(data.show_data[k] * 1000)
          } else {
            temp[kk] = data.show_data[k]
          }
        }
        data.show_data = temp
        this.info = data
      },rej=> {
        this.$messageBox.alert(rej.msg, 'Error', {
          type: 'error',
            callback: () => {
              this.$router.push({path: '/riches'})
            }
        })
      })
    },
    titleCase(str) {
      str = str.split(' ');
      for (var i = 0; i < str.length; i++) {
        str[i] = str[i].slice(0, 1).toUpperCase() + str[i].slice(1);
      }
      return str.join(' ');
    },
    /* 提交 */
    submit() {
      if (this.info.trade_type == 'recharge') {
        // 如果是充值
        this.$router.push({name: 'Riches'})
      } else {
        // 如果是订单支付
        this.$refs.postForm.submit()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapContent{
  margin: 20px auto;
  >div{
    width: 580px;
    padding: 20px;
    @extend .shadow;
    margin: 0 auto;
    background: #fff;
    >h3{
      font-size: 18px;
      margin-bottom: 20px;
    }
    .main{
      h5{
        padding: 10px;
        color: #fff;
        background: $blue;
      }
      table{
        background: #f6f6f6;
        td{
          padding: 10px 8px;
          color: #333;
          &:first-child{
            width: 200px;
          }
        }
      }
      .btns{
        margin-top: 20px;
        text-align: right;
      }
    }
  }
  // background: #fff;
}

.success{
  color: $success;
}

.fail{
  color: $fail;
}
</style>